import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const ReviewsPage = () => {
  const pressReviews = [
    {
      id: 1,
      quote: "At the core of Leigh's practice is a belief that artists serve as visual historians. Her works are not just images but records of the time in which she lives, grief, intimacy, political uncertainty, and resilience captured in color and form.",
      source: "Tech News Vision",
      link: "https://www.technewsvision.com/leigh-witherell-vs-the-algorithm-navigating-censorship-in-the-digital-art-world/"
    },
    {
      id: 2,
      quote: "Leigh's artistic voice is distinct in its restraint. She avoids overly bright palettes, instead leaning into earth tones that invite viewers to see themselves within the frame. Her brushwork is urgent, sometimes impatient, which gives her compositions an honesty that feels immediate.",
      source: "NY Tabloid",
      link: "https://nytabloid.com/leigh-witherells-journey-through-grief-turning-loss-into-visual-storytelling/"
    },
    {
      id: 3,
      quote: "Leigh's art holds a quiet intensity—the kind that arrives from lived experience rather than theory. Her work looks at relationships, the human body, and the emotions that live in the small, often unspoken moments.",
      source: "LA Lifestyle Magazine",
      link: "https://lalifestylemag.com/beyond-the-canvas-leigh-witherells-stand-for-artistic-freedom-and-authentic-expression/"
    },
    {
      id: 4,
      quote: "For Leigh, a painting succeeds only if it captures the truth of a moment. She sees every work as part of a larger narrative about life, one made up of countless small stories.",
      source: "Big Time Daily",
      link: "https://www.bigtimedaily.com/every-life-is-a-story-leigh-witherells-art-of-capturing-connection/"
    }
  ];

  const collectorReviews = [
    {
      id: 1,
      name: "Lindsay Klug",
      artwork: "Grief",
      quote: "This piece really speaks to me. I can hear the sound of the wind as it blows through her hair, and the emotions it brings up are fierce. This woman could be grieving, or sad for another reason, but to me, she represents someone who is tired of battling forward in this crazy life.",
      images: ["https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/ce6feced-787b-4955-9b0a-7f2d16f3c4dd/IMG_8509.jpg"]
    },
    {
      id: 2,
      name: "TK Reiter",
      artwork: "Intimate Equality",
      quote: "Intimate Equality – Leigh Witherell's painting of two lovers is a deeply moving work that captures the essence of intimacy and human connection. The semi-nude figures of man and woman are portrayed with such tenderness that the composition radiates romance, affection, and a profound sense of security. Every brushstroke conveys warmth and vulnerability, inviting the viewer to feel the quiet strength of love in its purest form. It is a piece that not only enriches the room it hangs in, but also stirs the heart each time it is seen.",
      images: ["https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/52b12c1e-3afd-4f6f-8ac7-17ccf1aa4c63/IMG_4078.jpg"]
    },
    {
      id: 3,
      name: "Alle Shane",
      artwork: "The Lover's Kiss",
      quote: "I had the privilege of adding The Lover's Kiss by Leigh Witherell to my collection, and it has quickly become the centerpiece of my home. The piece is absolutely stunning capturing the intimate, timeless feeling of looking out into a moment shared between two lovers along the Mediterranean. What makes it even more special is the way it's displayed. The unique hanging that Leigh's work specialises draws your eye from the side first, creating a sense of discovery before you're met with the full beauty from the front. It's truly unlike anything else I own. Every guest who visits comments on it, it's the artwork that gets the most attention and admiration in my condo. Leigh has an excellent ability to create something both personal and universal, full of movement and soul. I feel fortunate to have found her at this stage of her career, and I'm excited to watch her continue to grow and collaborate with other artists.",
      images: ["https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/9a3ccfd5-e01e-4b5a-a773-9ae82944ab5a/The+Lovers+Kiss-highRes-20241110-fotor-202411271446.jpg"]
    },
    {
      id: 4,
      name: "April and Joe Dallara",
      artwork: "The Wreck",
      quote: "The water and boats are Joe's favorites things. It looks amazing on the wall near the front door. Every time someone walks into the house they stop and stare at the painting. They couldn't believe what an incredible painter you are.",
      images: ["https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/f60d9b5c-17a9-4d89-b0be-92cbf8fbee1d/The+Wreck+-+MedLowRes+-+20250103.jpg"]
    },
    {
      id: 5,
      name: "Analise Reiter",
      quote: "We are fortunate to have several of Leigh Witherell's artworks adorning our home, bringing warmth and character to nearly every room. The vibrant interplay of colors blends beautifully with our interior style, creating a harmonious atmosphere that feels both elegant and full of life. Each piece is not only a visual delight but also adds a unique sense of depth and personality to our living space. Among our favorites are Phoenix Rising, FOG, Sunflowers in Abstract, Emergence, Abstract in Gold, and Sisters, each with its own distinct energy, yet together forming a collection that feels perfectly at home with us.",
      images: []
    }
  ];

  return (
    <div className="min-h-screen bg-off-black">
      <Navigation />

      {/* Content */}
      <div className="pt-24 sm:pt-28 md:pt-32 pb-16 sm:pb-24 md:pb-32 px-4 sm:px-6">
        <div className="max-w-5xl mx-auto">
          {/* Page Title */}
          <div className="mb-12 sm:mb-16 md:mb-24">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif text-soft-ivory tracking-tight mb-3 sm:mb-4">
              Reviews
            </h1>
            <div className="w-16 sm:w-20 h-1 bg-flesh-tone"></div>
          </div>

          {/* Press Section */}
          <section className="mb-20 sm:mb-24 md:mb-32">
            <h2 className="text-xs uppercase tracking-widest text-muted-warm-grey mb-8 sm:mb-12">
              Press
            </h2>

            <div className="space-y-8 sm:space-y-12">
              {pressReviews.map((review) => (
                <div key={review.id} className="border-l-2 border-flesh-tone pl-4 sm:pl-8">
                  <blockquote className="text-base sm:text-lg md:text-xl leading-relaxed text-soft-ivory mb-3 sm:mb-4">
                    "{review.quote}"
                  </blockquote>
                  <cite className="not-italic">
                    <a
                      href={review.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm sm:text-base text-muted-warm-grey hover:text-flesh-tone transition-colors duration-400"
                    >
                      — {review.source}
                    </a>
                  </cite>
                </div>
              ))}
            </div>
          </section>

          {/* Collectors Section */}
          <section>
            <h2 className="text-xs uppercase tracking-widest text-muted-warm-grey mb-8 sm:mb-12">
              Collectors
            </h2>

            <div className="space-y-16 sm:space-y-20 md:space-y-24">
              {collectorReviews.map((review) => (
                <div key={review.id}>
                  {/* Images First */}
                  {review.images && review.images.length > 0 && (
                    <div className="mb-6 sm:mb-8">
                      {review.images.length === 1 ? (
                        <div className="max-w-2xl">
                          <img
                            src={review.images[0]}
                            alt={`${review.artwork || 'Artwork'} in ${review.name}'s collection`}
                            className="w-full h-auto object-cover border border-zinc-800"
                          />
                        </div>
                      ) : (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 max-w-4xl">
                          {review.images.map((img, idx) => (
                            <div key={`${review.id}-img-${idx}`}>
                              <img
                                src={img}
                                alt={`${review.artwork || 'Artwork'} in ${review.name}'s collection`}
                                className="w-full h-auto object-cover border border-zinc-800"
                              />
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  {/* Review Text Below */}
                  <div className="max-w-3xl">
                    <div className="border-l-2 border-flesh-tone pl-4 sm:pl-8">
                      {review.artwork && (
                        <p className="text-xs uppercase tracking-widest text-muted-warm-grey mb-3 sm:mb-4">
                          {review.artwork}
                        </p>
                      )}
                      <blockquote className="text-base sm:text-lg leading-relaxed text-soft-ivory mb-4 sm:mb-6">
                        {review.quote}
                      </blockquote>
                      <cite className="not-italic text-muted-warm-grey text-sm">
                        — {review.name}
                      </cite>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ReviewsPage;
